import type { Components, Theme } from '@mui/material/styles';

export const alertTheme: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: {
      borderRadius: '12px'
    },
    outlinedInfo: ({ theme }) => ({
      color: `${theme.vars.palette.semantic.text.primary} !important`,
      border: `1px solid ${theme.vars.palette.semantic.border.primary} !important`,
      '& .MuiAlert-icon': {
        color: `${theme.vars.palette.semantic.text.accent} !important`
      }
    }),
    standardInfo: ({ theme }) => ({
      color: 'rgba(0, 0, 0, 0.87)',
      background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${theme.vars.palette.primitive.blue[900]}`,
      '& .MuiAlert-icon': {
        color: `${theme.vars.palette.semantic.text['accent-strong']} !important`
      }
    }),
    standardError: ({ theme }) => ({
      '& .MuiAlert-icon': {
        color: `${theme.vars.palette.primitive.red[700]} !important`
      }
    }),
    standardSuccess: ({ theme }) => ({
      '& .MuiAlert-icon': {
        color: `${theme.vars.palette.semantic.text.success} !important`
      }
    }),
    standardWarning: ({ theme }) => ({
      '& .MuiAlert-icon': {
        color: `${theme.vars.palette.primitive.orange[700]} !important`
      }
    })
  }
};

export const alertTitleTheme: Components<Theme>['MuiAlertTitle'] = {
  styleOverrides: {
    root: {
      color: 'inherit',
      fontSize: '1rem'
    }
  }
};
